import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";


const BorderButton = ({ children, url, button_color, button_border, button_text }) => {

  const [buttonSize, setButtonSize] = useState('');
  
  const isMobile = useMediaQuery({ maxWidth: 551 });
  const isTablet = useMediaQuery({ minWidth: 551, maxWidth: 801 });
  const isDesktop = useMediaQuery({ minWidth: 802 });

  useEffect(() => {
    if (isMobile) {
      setButtonSize('btn-sm');
    }
    
    if (isTablet) {
      setButtonSize('');
    }
    
    if (isDesktop) {
      setButtonSize('');
    }
  }, [isMobile, isTablet, isDesktop]);


  return (

    <>
    
      <Link to={url} className={`btn ${buttonSize} btn-${button_color} border-3 border-${button_border} text-${button_text} font-custom`}>{children}</Link>
    
    </>

  );
}


export default BorderButton;